import { bool, func, string, number } from 'prop-types'
import TextInput from '../../Inputs/Input/InputV2'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const SearchBar = ({
  focusOnMount,
  onSearch,
  icon,
  iconSize,
  onBlur,
  placeholderText,
  value,
}) => (
  <div className={kuiperClassNames('search')}>
    {renderIcon(icon, {
      height: iconSize,
      width: iconSize,
      ariaMode: 'hidden',
    })}
    <TextInput
      focusOnMount={focusOnMount}
      value={value}
      theme="light invisible"
      onBlur={onBlur}
      onChange={onSearch}
      placeholder={placeholderText}
    />
  </div>
)

SearchBar.propTypes = {
  focusOnMount: bool,
  icon: string,
  iconSize: number,
  onBlur: func,
  onSearch: func,
  placeholderText: string,
  value: string,
}

export default SearchBar
